<template>
	<div>
		<a @click="show = true">
			<span v-if="isCurrency">{{ total | currency }}</span>
			<span v-else>{{ total }}</span>
		</a>
		<app-dialog
			v-model="show"
			max-width="500"
		>
			<app-dialog-body>
				<app-row class="font-weight-bold text-uppercase ma-2">
					<app-cell xs6>{{labelName}}</app-cell>
					<app-cell xs6>{{labelValue}}</app-cell>
				</app-row>
				<app-row class="ma-2" v-for="detail in details" :key="detail.name">
					<app-cell xs6>{{detail.name}}</app-cell>
					<app-cell xs6>
						<span v-if="isCurrency">{{ detail.value | currency }}</span>
						<span v-else>{{ detail.value }}</span>
					</app-cell>
				</app-row>
				<app-divider />
				<app-row class="ma-2">
					<app-cell xs6 class="font-weight-bold">Total</app-cell>
					<app-cell xs6>
						<span v-if="isCurrency">{{ total | currency }}</span>
						<span v-else>{{ total }}</span>
					</app-cell>
				</app-row>
			</app-dialog-body>
			<app-dialog-footer>
				<app-button
					color="primary"
					flat="flat"
					@click="show = false"
				>
					Close
				</app-button>
			</app-dialog-footer>
		</app-dialog>
	</div>
</template>

<script>
export default {
	props: {
		total: {
			type: Number,
			required: true,
		},
		details: {
			type: Array,
			required: true,
		},
		labelName: {
			type: String,
			default: 'Name',
		},
		labelValue: {
			type: String,
			default: 'Value',
		},
		isCurrency: {
			type: Boolean,
			detault: false,
		},
	},
	data() {
		return {
			show: false,
		}
	},
}
</script>
